import { Box, tokens } from "shared/components/Spor";
import { styled } from "styled-components";

interface OverlayProps {
  $open?: boolean;
  zIndex?: number;
}

const Overlay = styled(Box)<OverlayProps>`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: ${({ theme }) => theme.overlayColor};
  z-index: ${({ zIndex }) => zIndex ?? tokens.default.depth["z-index"].overlay};
  opacity: ${({ $open = true }) => ($open ? 1 : 0)};
  visibility: ${({ $open = true }) => ($open ? "visible" : "hidden")};
  pointer-events: ${({ $open = true }) => ($open ? "auto" : "none")};

  transition:
    opacity 0.3s ease-in-out,
    visibility 0.3s ease-in-out;
`;

export default Overlay;
